import Breadcrumb, { BreadcrumbItem } from '@/components/common/Breadcrumb';
import { ChevronLeft } from 'lucide-react';
import React from 'react';

interface HeaderProps {
  title: string;
  breadcrumbs: BreadcrumbItem[];
  onBack?: () => void;
  lastUpdated?: string;
  rightContent?: React.ReactNode;
}

const ContentHeader: React.FC<HeaderProps> = ({
  title,
  breadcrumbs,
  onBack,
  lastUpdated,
  rightContent,
}) => {
  return (
    <header className="w-full border-b bg-white font-noto">
      <div className="px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex flex-col sm:flex-row sm:items-center gap-6">
          {onBack && (
            <button
              onClick={onBack}
              className="text-lg font-semibold text-darkPurple hover:text-lightPurple bg-[#F7EFFF] px-4 py-2 border-r-2 border-darkPurple"
            >
              <p className="flex items-center">
                <ChevronLeft /> <span className="text-xs sm:text-[16px]">Back</span>
              </p>
            </button>
          )}

          <div className="flex flex-col gap-1">
            <Breadcrumb items={breadcrumbs} />
            {/* <h1 className="text-xl font-semibold text-gray-900">{title}</h1> */}
          </div>
        </div>

        {/* Right Section */}
        {/* <div className="flex items-center gap-4">
          {lastUpdated && (
            <span className="text-sm text-lightPurple">Last Updated: {lastUpdated}</span>
          )}
          {rightContent}
        </div> */}
      </div>
    </header>
  );
};

export default ContentHeader;
